export const backendUrls = {
    PRODUCT_ACTIVATIONS_API: import.meta.env.VITE_PRODUCT_ACTIVATIONS_API,
    ASSETS_API: import.meta.env.VITE_ASSET_ADMINISTRATION,
    UNITS_API: import.meta.env.VITE_UNITS_API,
};
